import React, { useEffect, useRef } from 'react';
import api from '../api';

const SessionManager = () => {
    const lastActivityRef = useRef(Date.now());

    useEffect(() => {
        const updateActivity = () => {
            lastActivityRef.current = Date.now();
        };

        // Attach listeners for user activity
        window.addEventListener('mousemove', updateActivity);
        window.addEventListener('keydown', updateActivity);
        window.addEventListener('click', updateActivity);
        window.addEventListener('scroll', updateActivity);

        // Every 4 minutes, check if user was active in the last 5 minutes.
        // If so, refresh the JWT token to prevent unexpected session timeouts.
        const intervalId = setInterval(() => {
            const token = localStorage.getItem('token');
            if (token && (Date.now() - lastActivityRef.current < 5 * 60 * 1000)) {
                api.post('/auth/refresh')
                    .then(res => {
                        if (res.data && res.data.access_token) {
                            localStorage.setItem('token', res.data.access_token);
                        }
                    })
                    .catch(err => {
                        console.error("Session token refresh failed:", err);
                    });
            }
        }, 4 * 60 * 1000); 

        return () => {
            window.removeEventListener('mousemove', updateActivity);
            window.removeEventListener('keydown', updateActivity);
            window.removeEventListener('click', updateActivity);
            window.removeEventListener('scroll', updateActivity);
            clearInterval(intervalId);
        };
    }, []);

    return null; // This component does not render anything
};

export default SessionManager;
